import { Component } from '@theme/component';

class APHeaderContact extends Component {
  connectedCallback() { super.connectedCallback(); this.initialize(); }
  updatedCallback() { super.updatedCallback(); this.initialize(); }
  initialize() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const details = this.querySelector('details');
    const trigger = this.querySelector('summary');
    if (!details || !trigger) return;
    trigger.addEventListener('click', event => {
      event.preventDefault();
      details.open = !details.open;
    }, options);
    document.addEventListener('pointerdown', event => {
      if (!this.contains(event.target)) details.open = false;
    }, options);
    document.addEventListener('focusin', event => {
      if (!this.contains(event.target)) details.open = false;
    }, options);
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault(); event.stopPropagation();
        details.open = false; trigger.focus();
      }
    }, options);
  }
  disconnectedCallback() { this.controller?.abort(); super.disconnectedCallback(); }
}
if (!customElements.get('ap-header-contact')) customElements.define('ap-header-contact', APHeaderContact);
